(function ($) {
    //
    // $(window).on('keypress', function(e) {
    //     if (e.which === 65) { // shift +] A
    //         $('.modal-nature').addClass('active');
    //         $('body').addClass('overflow-hidden');
    //     }
    // })
    if ($('.modal-nature').length || $('section.development-houses-modal').length) {
        // const modalNatureSwiper = new Swiper('.modal-nature .modal-nature-swiper', {
        //     autoHeight: true,
        //     hashNavigation: {
        //         watchState: true
        //     },
        //     loop: false,
        //     keyboard: {
        //         enabled: true,
        //     },
        //     pagination: {
        //         el: '.swiper-pagination',
        //         type: 'fraction',
        //     },
        //     navigation: {
        //         nextEl: '.swiper-button-next',
        //         prevEl: '.swiper-button-prev',
        //     },
        //
        // });
        // $('.modal-nature .close-button').on('click',function(){
        //     $('.modal-nature.active').removeClass('active');
        //     $('body.overflow-hidden').removeClass('overflow-hidden');
        // })
        // $('.faq-block .question').on('click', function () {
        //     $(this).parent().toggleClass('active').find('.answer').slideToggle();
        //
        // })
        //
        // $('.faq-block .question').on('keypress', function(e) {
        //     if (e.which === 13) {
        //         $(this).parent().toggleClass('active').find('.answer').slideToggle();
        //     }
        // });
    }
})(jQuery);
